import { render, staticRenderFns } from "./a-promo-code.vue?vue&type=template&id=6b12ec2e&scoped=true&"
import script from "./a-promo-code.vue?vue&type=script&lang=js&"
export * from "./a-promo-code.vue?vue&type=script&lang=js&"
import style0 from "./a-promo-code.vue?vue&type=style&index=0&id=6b12ec2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b12ec2e",
  null
  
)

export default component.exports